import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild, TemplateRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map} from 'rxjs';
import { NgForm } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LegalDateTimeService } from '../../../services/legal-datetime.service';

@Component({
  selector: 'app-create-job-2',
  templateUrl: './create-job-2.component.html',
  styleUrls: ['./create-job-2.component.css']
})
export class CreateJob2Component implements OnInit {
  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  job: any;
  JobStep2ID: any;
  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  clients: any;
  client_contacts: any;
  sent_client_id: any;
  positionsMysql: any;
  get_subjects: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  job_service_rule: any;
  selected_job_service_rule_description: string;
  job_service_timeframe: any;
  selected_job_service_timeframe_description: string;
  job_service_rules: any;
  job_service_timeframes: any;
  subject_service_types: any;
  subject_service_type: any;
  selected_subject_service_type_description: string;
  selected_subject_service_type_instructions: string;
  selected_subject_service_type_staff_instructions: string;
  SubjectForm: any;
  job_type_document_type: any;
     // access the template form
     @ViewChild('jobForm') jobForm: NgForm;
  modalRef: any;
  job_plaintiffs: any;
  job_id: number;
  sessionUsername: any;
  all_router_details: string;
  jobDatePickerValues: { [key: string]: { [field: string]: Date | null } } = {};
  private readonly legalJobDateFields = ['judgement_date', 'filing_date', 'hearing_date', 'instructions_date'];

  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public gfunc: GlobalFunctionsService,
     private modalService: BsModalService,
     public legalDate: LegalDateTimeService,
     ) {

      this.nav = document.querySelector('nav.navbar');


    // login vars
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));



      }

  ngOnInit() {
    this.JobStep2ID = +this.route.snapshot.paramMap.get('job_id');
    this.job_id = +this.route.snapshot.paramMap.get('job_id');

   this.getJob(this.JobStep2ID);
   this.getJobTypes();
   this.getPositions();
  // this.getJobTypeLocations(this.model.job_type_location_id); // loads default locations as nothing
    this.getJobSubjectTypes();
    this.getJobPlaintiffTypes();
    this.getJobServiceRules();
    this.getJobServiceTimeframes();

    


  }



getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
     data => { this.job = data;
      let res = data[0];
      this.initializeJobDatePickerValues(this.job);
      // Need to load the drop downs (only if a process is selected.)
      this.getJobTypeLocations(res.job_type_id);
      this.getJobTypeCourts(res.job_type_location_id);
      this.getJobTypeDocumentTypes(res.job_type_court_id);
      this.getJobTypeAffidavitTypes(res.job_type_document_type_id);

      this.getJobPlaintiffs(job_id);
    
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
}

getJobDateKey(model: any): string {
  return String(model?.job_id ?? '');
}

getJobDatePickerValue(model: any, field: string): Date | null {
  const key = this.getJobDateKey(model);
  return this.jobDatePickerValues[key]?.[field] ?? null;
}

onJobDateChange(field: string, value: unknown, model: any): void {
  const key = this.getJobDateKey(model);
  const pickerDate = this.legalDate.coercePickerDate(value);

  if (!this.jobDatePickerValues[key]) {
    this.jobDatePickerValues[key] = {};
  }

  this.jobDatePickerValues[key][field] = pickerDate;
  model[field] = this.legalDate.fromPickerDate(pickerDate);
}

private initializeJobDatePickerValues(jobs: any[]): void {
  if (!Array.isArray(jobs)) {
    this.jobDatePickerValues = {};
    return;
  }

  const jobDatePickerValues: { [key: string]: { [field: string]: Date | null } } = {};

  jobs.forEach((jobModel) => {
    const key = this.getJobDateKey(jobModel);
    jobDatePickerValues[key] = {};

    this.legalJobDateFields.forEach((field) => {
      jobDatePickerValues[key][field] = this.legalDate.toPickerDate(jobModel?.[field]);
    });
  });

  this.jobDatePickerValues = jobDatePickerValues;
}


// BOF SHARMANS CALLS
getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobSubjectTypes() {
  this._demoService.getJobSubjectTypes().subscribe(
     data => { this.job_subject_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobPlaintiffTypes() {
  this._demoService.getJobPlaintiffTypes().subscribe(
     data => { this.job_plaintiff_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypeLocations(job_type_id) {
  this._demoService.getJobTypeLocations(job_type_id).subscribe(
     data => { this.job_type_locations = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeLocationsID(job_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.count2 = job_type_id;
  this.getJobTypeLocations(this.count2); // updates the selected job ID....



 console.log('sending Count:' + this.count2);
}


getJobTypeCourts(job_type_location_id) {
  this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
     data => { this.job_type_courts = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeCourtsID(job_type_location_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_location_id = job_type_location_id;
  this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....



 console.log('sending Location:' + this.sent_job_type_location_id);
}


getJobTypeDocumentTypes(job_type_court_id) {
  this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
     data => { this.job_type_document_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeDocumentTypesID(job_type_court_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_court_id = job_type_court_id;
  this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....


 console.log('sending Court Type:' + this.sent_job_type_court_id);
}


getJobTypeAffidavitTypes(job_type_document_type_id) {
  this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
     data => { this.job_type_affidavit_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeAffidavitTypesID(job_type_document_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_document_type_id = job_type_document_type_id;
  this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

 console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
}



getClients() {
  this._demoService.getClients().subscribe(
     data => { this.clients = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getClientContactsSharmans(client_id) {
  this._demoService.getClientContactsSharmans(client_id).subscribe(
     data => { this.client_contacts = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 sendClientID(client_id) {
 this.sent_client_id = client_id;
 this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....

 console.log('sending Client ID:' + this.sent_client_id);
}

private getPositions() {
  this._demoService.getPositions()
    .subscribe(
      res => this.positionsMysql = res,
      err => console.error(err.status)
    );
}



// update was here for onit but moved for onchange
updateJobStep2(model) {
  this._demoService.updateJobStep2(model).subscribe(
     data => { // this.trace_candidate_update = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Job Updated');
     this.createJobSubjectsMultiple(model); // this function creates the subjects for the job
     // Subject to reload the manager component parent.
    // TraceCandidateManagerComponent.returned.next(false);
    // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
    this.gfunc.globalJobEditStep3(model.job_id);
               return true;
     },
     error => {
      // console.error('Error saving Event!');
       this.toastr.error('Error saving Job!');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
);
}



// create subjects
createJobSubjectsMultiple(model) {

// I have now modified this function to carry across job type ids in the insert scrupt to the subject.

   this._demoService.createJobSubjectsMuliple(model).subscribe(
      data => {  this.get_subjects = data; // this is the retuned json upon creation.
      this.toastr.success('Subjects Saving...');
      // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

       // Setup annd the Currents before we redirec the page
       // Needs to be a Function to update the ObserveOnOperator.
       // this.newCTrace_id(this.latest_trace_id);
       // or this.cdata.changeCTrace_id("999");
 
      // this.router.navigate(['/admin/jobs/create-job-2/' + model.job_id + '']);
 
      let cb = {
        ...this.get_subjects,
        ...model
      }
      this.gfunc.insertLog_CreateSubject(cb);

     return true;


        //  return true;
 
 
      },
      error => {
        this.gfunc.insertLog_CreateSubject(model);

      // console.log('Should be form Model' + model);
      // console.error('Error Creating a Trace Project!');
       // this.toastr.error('Adding Subjects Failed :: Please try again!');
       // console.log(error(error));
       //return console.log(error);
      }
 );
}







getJobServiceRule(job_service_rule_id) {
  this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
     data => { this.job_service_rule = data; 
      let res = data[0];
      if (job_service_rule_id <= 0 ){
        this.selected_job_service_rule_description = 'Not Applicable';
      };
      this.selected_job_service_rule_description = res.job_service_rule_description;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobServiceTimeframe(job_service_timeframe_id) {
  this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
     data => { this.job_service_timeframe = data; 
      let res = data[0];
      if (job_service_timeframe_id <= 0 ){
        this.selected_job_service_timeframe_description = 'Not Applicable';
      };
      this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobServiceRules() {
  this._demoService.getJobServiceRules().subscribe(
     data => { this.job_service_rules = data; },
     err => console.error(err),
      () => {
        console.log('done loading SR');
                    }
        );
 }


 getJobServiceTimeframes() {
  this._demoService.getJobServiceTimeframes().subscribe(
     data => { this.job_service_timeframes = data; },
     err => console.error(err),
      () => {
        console.log('done loading SR');
                    }
        );
 }


 getSubjectServiceTypes() {
  this._demoService.getSubjectServiceTypes().subscribe(
     data => { this.subject_service_types = data;  },
     err => console.error(err),
      () => {
        // console.log('done loading Subject Service Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }

 
getSubjectServiceType(subject_service_type_id) {
  this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
     data => { 
      this.subject_service_type = data;
      let res = data[0];
      if ( subject_service_type_id <= 0 ){
        this.selected_subject_service_type_description = 'Please Set to default Individual Above';
        this.selected_subject_service_type_description = '';
        this.selected_subject_service_type_instructions = '';
        this.selected_subject_service_type_staff_instructions = '';

      } 
      this.selected_subject_service_type_description = res.subject_service_type_description;
      this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
      this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;

      // initiate the change of service rule if different or select from drop down.
      if (subject_service_type_id > 1) {
      this.setJobServiceRule(res.job_service_rule_id_change_to);
      this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
      }

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




 setJobServiceRule(job_service_rule_id) {
  // sets the form value upon change of the subject_service_type
  this.SubjectForm.controls['job_service_rule_id'].setValue(job_service_rule_id);
  this.toastr.info('Service Rule modified due to Service Entity Type Change. Please Save Subject Changes.' + job_service_rule_id);
};

sendJobServiceRuleID(job_type_document_type_id) {
// this.initialCount = this.trace_candidates.trace_candidate_id;
// this.sent_job_service_rule_id = job_service_rule_id;

this.sent_job_type_document_type_id = job_type_document_type_id;
//  this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....



      //   IMPLIMENTATION of Service Timeframes & Service Rules associated with document selection
      // ::@ Try to set the service rule and service timeframes from document here.
      //    What is the current selected DocumentID - lookup the  timeframes, and service rule IDS
      //    Then set them into the model and save as new variables as part of the job.
      //     TODO:: need to impliment this on create a job and set for all subjects on a subject level with defaults.
      //  this.model.job_service_rule_id = 




// Now lookup the Serice rule and set the selection with the ids.
this.getJobTypeDocumentType(this.sent_job_type_document_type_id);
// NOW need to repeat this action for the service timeframes.


console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
}



getJobTypeDocumentType(job_type_document_type_id) {
this._demoService.getJobTypeDocumentType(job_type_document_type_id).subscribe(
   data => { this.job_type_document_type = data;
  let res = data[0];
  // Set the new form variables After the selected drop down of documents activated this function;
  // note :: SUCCESS (This also updates the model object variables in the form)
  this.jobForm.controls['job_service_rule_id'].setValue( res.job_service_rule_id);
  this.jobForm.controls['job_service_timeframe_id'].setValue( res.job_service_timeframe_id);

// Display the Rule Definition in UI/Template
// Need to do a quick lookup to get the values to set below both Timeframes and Rule Definitions on the page

this.getJobServiceRule(res.job_service_rule_id);
this.getJobServiceTimeframe(res.job_service_timeframe_id);





  // this.model.job_service_rule_id = res.job_service_rule_id;
  //   console.log('New job_service_rule_id ' + this.model.job_service_rule_id);
},
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobViewSkipRoute(this.job_id);
this.getJobPlaintiffs(this.job_id);
};

getJobPlaintiffs(job_id) {
  this._demoService.getJobPlaintiffs(job_id).subscribe(
     data => { this.job_plaintiffs = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }





 deleteJobPlaintiff(job_plaintiff_id) {
  if (confirm('Are you sure you want to delete this Plaintiff? ')) {
    this._demoService.deleteJobPlaintiff(job_plaintiff_id).subscribe(
       data => {
     // reset the plaintiff list.
     this.getJobPlaintiffs(this.job_id);
     this.toastr.warning('Plaintiff removed from job.');
         return true;
       },
       error => {
         console.error('Error deleting !');
        return console.log(error);
       }
    );
}
}


}

  // Allows formatting of dates etc...
  export class DatePipeComponent {
    today: number = Date.now();
    fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
  // tslint:disable-next-line:eofline
  }

